import React, { useContext, useState, useEffect, useRef } from 'react';
import DashboardHeader from '../../Components/DashboardHeader/DashboardHeader';
import Sidebar from '../../Components/Sidebar/Sidebar';
import { Button, Box, Tabs, Tab, CircularProgress } from '@mui/material';
import cross from '../../Assets/Images/cross.svg';
import Assessment from '../../Components/AssessmentDetail/Assessment';
import Members from '../../Components/AssessmentDetail/Members';
import AssessmentScores from '../../Components/AssessmentDetail/AssessmentScores';
import Reports from '../../Components/AssessmentDetail/Reports/Reports';
import { Link, useSearchParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import AuthContext from '../../Context/AuthContext';
import { fetchAssessments, fetchDeployments } from '../../api';
import Notification from '../../Components/Dashboard/Notification/Notification';
import Select from 'react-select';
import { AssessmentContext } from '../../Context/AssessmentContext';
import GroupReportContext from '../../Context/GroupReportContext';
import greentick from '../../Assets/Images/green-tick.svg';
import { validateName } from '../../utils/helper';

const CreateAssessment = () => {
  const titles = [
    { label: 'Other', value: 'Other' },
    { label: 'CEO', value: 'CEO' },
    { label: 'CFO', value: 'CFO' },
    { label: 'COO', value: 'COO' },
    { label: 'Director', value: 'Director' },
    { label: 'HR/People Manager', value: 'HR/People Manager' },
    { label: 'Administrator', value: 'Administrator' },
    { label: 'Team/Department Manager', value: 'Team/Department Manager' },
    { label: 'Service/Customer Service Manager', value: 'Service/Customer Service Manager' },
    { label: 'Project Manager', value: 'Project Manager' },
    { label: 'Supervisor', value: 'Supervisor' },
    { label: 'Marketing/Sales Consultant', value: 'Marketing/Sales Consultant' },
    { label: 'Accounting/Finance', value: 'Accounting/Finance' },
    { label: 'Operations Manager', value: 'Operations Manager' },
    { label: 'Logistics/Supply Chain Coordinator', value: 'Logistics/Supply Chain Coordinator' },
    { label: 'Executive Assistant', value: 'Executive Assistant' },
    { label: 'Nonprofit Leader', value: 'Nonprofit Leader' },
    { label: 'Pastor/Religious Leader', value: 'Pastor/Religious Leader' },
    { label: 'Athlete/Coach', value: 'Athlete/Coach' },
    { label: 'Entrepreneur/Small Business Owner', value: 'Entrepreneur/Small Business Owner' },
    { label: 'Personal Development Seeker', value: 'Personal Development Seeker' },
    { label: 'Consultant', value: 'Consultant' },
    { label: 'Educator/Trainer', value: 'Educator/Trainer' },
    { label: 'Creative Professional', value: 'Creative Professional' },
    { label: 'Health/Wellness Professional', value: 'Health/Wellness Professional' },
  ];

  const industries = [
    { label: 'Agriculture', value: 'Agriculture' },
    { label: 'Automotive', value: 'Automotive' },
    { label: 'Construction', value: 'Construction' },
    { label: 'Education/Training', value: 'Education/Training' },
    { label: 'Energy/Utilities', value: 'Energy/Utilities' },
    { label: 'Engineering', value: 'Engineering' },
    { label: 'Entertainment/Media', value: 'Entertainment/Media' },
    { label: 'Finance/Banking', value: 'Finance/Banking' },
    { label: 'Government/Public Services', value: 'Government/Public Services' },
    { label: 'Healthcare/Medical', value: 'Healthcare/Medical' },
    { label: 'Hospitality/Tourism', value: 'Hospitality/Tourism' },
    { label: 'Information Technology (IT)', value: 'Information Technology (IT)' },
    { label: 'Insurance', value: 'Insurance' },
    { label: 'Leadership Development/Consulting', value: 'Leadership Development/Consulting' },
    { label: 'Legal Services', value: 'Legal Services' },
    { label: 'Manufacturing/Production', value: 'Manufacturing/Production' },
    { label: 'Marketing/Advertising', value: 'Marketing/Advertising' },
    { label: 'Non-Profit/Charity/Churches', value: 'Non-Profit/Charity/Churches' },
    { label: 'Real Estate/Property', value: 'Real Estate/Property' },
    { label: 'Transportation/Logistics', value: 'Transportation/Logistics' },
  ];

  const customStyles = {
    border: 'none',
    control: (base, state) => ({
      ...base,
      height: 50,
      minHeight: 50,
      width: '97%',
      borderColor: state.isFocused ? '#5795B2' : base.borderColor,
      boxShadow: state.isFocused ? '0 0 0 1px #5795B2' : base.boxShadow,
      '&:hover': { borderColor: state.isFocused ? '#5795B2' : base.borderColor },
    }),
    valueContainer: (provided) => ({ ...provided, height: '48px', padding: '0 15px' }),
    input: (provided) => ({ ...provided, margin: '0px', height: '48px' }),
    placeholder: (base) => ({
      ...base,
      fontFamily: 'Lato, sans-serif',
      color: '#C7C7C7',
      fontSize: 18,
      lineHeight: '21.6px',
      fontWeight: 400,
    }),
    singleValue: (base) => ({
      ...base,
      fontFamily: 'Lato, sans-serif',
      color: '#303030',
      fontSize: 18,
      lineHeight: '21.6px',
      fontWeight: 400,
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base) => ({ ...base, padding: '8px' }),
    indicatorsContainer: (base) => ({ ...base, paddingRight: '10px' }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#426B88' : state.isFocused ? '#DDEAF0' : 'white',
      color: state.isSelected ? 'white' : '#303030',
      fontFamily: 'Lato, sans-serif',
      fontSize: 16,
      cursor: 'pointer',
    }),
  };

  const asmtCtx = useContext(AssessmentContext);
  const groupReportCtx = useContext(GroupReportContext);
  const [value, setValue] = useState(0);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const indicatorWidths = ['60px', '110px', '70px'];
  const [existingEmails, setExistingEmails] = useState([]);


  const notificationRef = useRef(null);
  const hasFetched = useRef(false);          
  const prevIdRef = useRef(null);    
  const { id } = useParams();

  const [formValues, setFormValues] = useState({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    title: '',
    type_text: '',
    company: '',
    industry: '',
    groupID: '',
  });

  const [selectedReportParams, setSelectedReportParams] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const tabParam = searchParams.get('tab');
    const assessmentIdParam = searchParams.get('assessmentId');
    const reportTypeParam = searchParams.get('reportType');

    if (tabParam === 'reports') {
      setSelectedReportParams({
        assessmentId: assessmentIdParam,
        reportType: reportTypeParam,
      });
    }
  }, [searchParams]);

  useEffect(() => {
    if (asmtCtx.tabValue === 0 || asmtCtx.tabValue === 1) {
      searchParams.delete('tab');
      searchParams.delete('assessmentId');
      searchParams.delete('reportType');
      setSearchParams(searchParams, { replace: true });
    }
  }, [asmtCtx.tabValue]); // eslint-disable-line react-hooks/exhaustive-deps



  const [errors, setErrors] = useState({
    firstnameError: '',
    lastnameError: '',
    emailError: '',
    phoneError: '',
    titleError: '',
    companyError: '',
    industryError: '',
    groupIDError: '',
  });

  const [editProfile, setEditProfile] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const location = useLocation();

  const [client, setClient] = useState(() => {
    const stateClient = location.state?.client;
    const storedClientLocal = JSON.parse(localStorage.getItem('clientData'));
    return stateClient || storedClientLocal || null;
  });

  useEffect(() => {
    if (client) {
      localStorage.setItem('clientData', JSON.stringify(client));
    }
  }, [client]);

  useEffect(() => {
    const fetchAllClientEmails = async () => {
      try {
        const allClients = await fetchDeployments(authCtx);
        const emails = allClients.map(client => client.email.toLowerCase()).filter(Boolean);
        setExistingEmails(emails);
      } catch (error) {
        console.error("Failed to fetch client emails:", error);
      }
    };
  
    fetchAllClientEmails();
  }, [authCtx]);

  // ======== FETCH CLIENT DATA (guarded; no context object in deps) ========
  useEffect(() => {
    // reset guard if route id changes
    if (prevIdRef.current !== id) {
      hasFetched.current = false;
      prevIdRef.current = id;
    }
    if (!id || hasFetched.current) return;

    const fetchClientData = async () => {
      setIsLoading(true);
      try {
        const clientData = await fetchDeployments(authCtx);
        if (clientData?.length > 0) {
          const currentClient = clientData.find((c) => c.id == id);
          if (currentClient) {
            const assessments = await fetchAssessments(currentClient.id);
            // safe to set in context; but DO NOT add groupReportCtx to deps
            groupReportCtx?.setSelectedAsmtList(assessments);

            const completeAssessments = assessments.filter((a) => a.status === 'complete');

            const updatedClient = {
              ...currentClient,
              totalAssessments: assessments?.length || 0,
              completeAssessments: completeAssessments.length,
              pendingAssessment: (assessments?.length || 0) - completeAssessments.length,
              assessments,
            };

            setClient(updatedClient);
            localStorage.setItem('clientData', JSON.stringify(updatedClient));
            window.dispatchEvent(new CustomEvent('clientDataUpdated', { detail: { updatedClient } }));
            hasFetched.current = true; // mark done for this id
          }
        }
      } catch (error) {
        console.error('Error fetching client data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchClientData();
  }, [id, authCtx?.token, groupReportCtx]); // groupReportCtx in deps won't re-run unless its identity changes

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setIsNotificationOpen(false);
      }
    };

    if (isNotificationOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [isNotificationOpen]);

  // ---------- FIX: correctly detect predefined vs custom title ----------
  useEffect(() => {
    if (client) {
      const isPredefined = titles.some((t) => t.value === client.title);
      setFormValues({
        firstname: client?.firstName || client?.name?.split(' ')[0] || '',
        lastname: client?.lastName || client?.name?.split(' ')[1] || '',
        email: client.email || '',
        phone: client.phone || '',
        title: isPredefined ? client.title : '',
        type_text: !isPredefined ? client.title || '' : '',
        company: client.company || '',
        industry: client.industry || '',
        groupID: client.groupid || '',
      });
    }
  }, [client]); // ---------------------------------------------------------------------

  // regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const validNameRegex = /^[a-zA-Z\s.''\-]{2,}$/;
  const validPhoneRegex = /^\d{10}$/;

  const extractNumber = (number) => number.replace(/\D/g, '');

  const handleChange = (event, newValue) => {
    if (newValue >= 0) {
      asmtCtx.setTabValue(newValue);
    }
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;

    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
    setErrors((prev) => ({ ...prev, [`${name}Error`]: '' }));

    switch (name) {
      case 'firstname':
        if (!value.trim()) {
          setErrors(prev => ({ ...prev, firstnameError: 'Please enter your first name.' }));
        } else {
          const firstNameError = validateName(value);
          if (firstNameError && firstNameError !== 'Please enter a valid name.') {
            setErrors(prev => ({ ...prev, firstnameError: firstNameError }));
          } else if (!validNameRegex.test(value)) {
            setErrors(prev => ({ ...prev, firstnameError: 'Please enter a valid first name.' }));
          } else {
            setErrors(prev => ({ ...prev, firstnameError: '' }));
          }
        }
        break;
      case 'lastname':
        if (!value.trim()) {
          setErrors(prev => ({ ...prev, lastnameError: 'Please enter your last name.' }));
        } else {
          const lastNameError = validateName(value);
          if (lastNameError && lastNameError !== 'Please enter a valid name.') {
            setErrors(prev => ({ ...prev, lastnameError: lastNameError }));
          } else if (!validNameRegex.test(value)) {
            setErrors(prev => ({ ...prev, lastnameError: 'Please enter a valid last name.' }));
          } else {
            setErrors(prev => ({ ...prev, lastnameError: '' }));
          }
        }
        break;
        case 'email':
          const newEmail = value.toLowerCase();
          const originalEmail = client?.email?.toLowerCase(); // The email before editing
        
          setErrors((prev) => {
            if (!emailRegex.test(value)) {
              return { ...prev, emailError: 'Please enter a valid email address.' };
            }
            // Check if the new email exists and is not the client's original email
            if (existingEmails.includes(newEmail) && newEmail !== originalEmail) {
              return { ...prev, emailError: 'This email is already used by another client.' };
            }
            return { ...prev, emailError: '' };
          });
          break;      case 'phone':
        setErrors((prev) => ({ ...prev, phoneError: !validPhoneRegex.test(extractNumber(value)) ? 'Please enter a valid phone number.' : '' }));
        break;
      case 'title':
        setErrors((prev) => ({ ...prev, titleError: value.trim() === '' ? 'Please enter your job title.' : '' }));
        break;
      case 'company':
        setErrors((prev) => ({ ...prev, companyError: value.trim() === '' ? 'Please enter your company name.' : '' }));
        break;
      case 'industry':
        setErrors((prev) => ({ ...prev, industryError: value.trim() === '' ? 'Please select/enter your industry.' : '' }));
        break;
      default:
        break;
    }
  };


  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!validNameRegex.test(formValues.firstname) || formValues.firstname.trim() === '') {
      newErrors.firstnameError = 'Please enter your first name';
      valid = false;
    } else {
      const firstNameError = validateName(formValues.firstname);
      if (firstNameError && firstNameError !== 'Please enter a valid name.') {
        newErrors.firstnameError = firstNameError;
        valid = false;
      }
    }
    
    if (!validNameRegex.test(formValues.lastname) || formValues.lastname.trim() === '') {
      newErrors.lastnameError = 'Please enter your last name';
      valid = false;
    } else {
      const lastNameError = validateName(formValues.lastname);
      if (lastNameError && lastNameError !== 'Please enter a valid name.') {
        newErrors.lastnameError = lastNameError;
        valid = false;
      }
    }
    if (!emailRegex.test(formValues.email)) {
      newErrors.emailError = 'Please enter a valid email';
      valid = false;
    } else {
      const newEmail = formValues.email.toLowerCase();
      const originalEmail = client?.email?.toLowerCase();
      if (existingEmails.includes(newEmail) && newEmail !== originalEmail) {
        newErrors.emailError = 'This email is already used by another client.';
        valid = false;
      }
    }
    if (!validPhoneRegex.test(extractNumber(formValues.phone))) {
      newErrors.phoneError = 'Please enter a valid phone number';
      valid = false;
    }
    if (formValues?.title?.trim() === '' && formValues?.type_text?.trim() === '') {
      newErrors.titleError = 'Please select/enter your title.';
      valid = false;
    }
    if (formValues.company.trim() === '') {
      newErrors.companyError = 'Please enter a company name';
      valid = false;
    }
    if (formValues.industry.trim() === '') {
      newErrors.industryError = 'Please enter an industry';
      valid = false;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const buildFinalTitle = () => {
    const custom = (formValues.type_text || '').trim();
    if (custom.length > 0) return custom;
    return formValues.title || '';
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    const finalTitle = buildFinalTitle();

    const data = {
      title: finalTitle,
      properties: [
        { property: 'email', value: formValues?.email },
        { property: 'name', value: formValues?.firstname + ' ' + formValues?.lastname },
        { property: 'firstName', value: formValues?.firstname },
        { property: 'lastName', value: formValues?.lastname },
        { property: 'industry', value: formValues?.industry },
        { property: 'phone', value: extractNumber(formValues?.phone) },
        { property: 'company', value: formValues?.company },
        { property: 'groupid', value: formValues?.groupID },
        { property: 'url', value: formValues?.url || '' },
        { property: 'started', value: formValues?.started || new Date() },
        // Optional: also persist title inside properties if backend reads from it
        { property: 'title', value: finalTitle },
      ],
    };

    const { title, properties } = data;
    const requestBody = { assessmentId: 78, title, properties };

    const orgId = authCtx?.orgId || localStorage.getItem('orgId');
    const apiUrl = `${process.env.REACT_APP_API_URI}/v4/organisation/${orgId}/deployments/${id}`;

    fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${authCtx.token}`,
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then(async (data) => {
        if (data.status === 'success') {
          setEditProfile(false);
          const clientData = await fetchDeployments(authCtx);
          const updatedClient = clientData.find((c) => c?.id == id);
          if (updatedClient) {
            const assessments = await fetchAssessments(updatedClient.id);
            const completeAssessments = assessments.filter((a) => a.status === 'complete');

            const clientWithAssessments = {
              ...updatedClient,
              totalAssessments: assessments?.length || 0,
              completeAssessments: completeAssessments.length,
              pendingAssessment: (assessments?.length || 0) - completeAssessments.length,
              assessments,
            };

            setClient(clientWithAssessments);
            localStorage.setItem('clientData', JSON.stringify(clientWithAssessments));
            window.dispatchEvent(new CustomEvent('clientDataUpdated', { detail: { updatedClient: clientWithAssessments } }));

            setShowSuccessMessage(true);
            setEditProfile(false);

            window.history.replaceState(
              { ...window.history.state, client: clientWithAssessments },
              '',
              `/client/${id}`
            );
          }
        } else {
          console.error('Error updating client:', data);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleNotificationOpen = () => setIsNotificationOpen(true);
  const handleNotificationClose = () => setIsNotificationOpen(false);

  const formatPhoneNumber = (value) => {
    let cleaned = value?.replace(/\D/g, '');
    let formatted = '';
    if (cleaned?.length > 6) {
      formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    } else if (cleaned?.length > 3) {
      formatted = `(${cleaned?.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else if (cleaned?.length > 0) {
      formatted = `(${cleaned}`;
    }
    return formatted;
  };

  // ---------- FIX: correct error key for industry; show text when 'Other' ----------
  const handleSelectChange = (selectedOption, fieldName) => {
    const value = selectedOption?.value || '';

    setFormValues((prev) => ({
      ...prev,
      [fieldName]: value,
      ...(fieldName === 'title' && value === 'Other' ? { type_text: '' } : {}),
    }));

    if (fieldName === 'title') {
      setErrors((prev) => ({
        ...prev,
        titleError: value.trim() === '' ? 'Please enter your job title.' : '',
      }));
    }
    if (fieldName === 'industry') {
      setErrors((prev) => ({
        ...prev,
        industryError: value.trim() === '' ? 'Please enter your industry.' : '',
      }));
    }
  };
  // ----------------------------------------------------------------------

  if (isLoading) {
    return (
      <div className="loading-container" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="dashboard-platform-client">
      <DashboardHeader heading="Clients" handleNotificationOpen={handleNotificationOpen} />
      <Notification ref={notificationRef} handleNotificationClose={handleNotificationClose} isNotificationOpen={isNotificationOpen} />

      <div className="clients-container-ass">
        <div className="info-header">
          <p className="page-name">
            <span className="clients" onClick={() => navigate('/clients')}>Clients &gt; </span>
            <span className="create">{client?.name || client?.title}</span>
          </p>
          <Link to="/clients">
            <img src={cross} alt="cross" className="cross-image" />
          </Link>

          <h2>{client?.name || client?.title}</h2>
          <p className="pform">{client?.company || 'Wayne Enterprises'}</p>
        </div>
        <div className="tab">
          <Box sx={{ width: '100%' }}>
            <Tabs
              value={asmtCtx.tabValue}
              onChange={handleChange}
              className="tab-name"
              TabIndicatorProps={{
                style: {
                  backgroundColor: '#BF9540',
                  height: '4px',
                  width: indicatorWidths[asmtCtx.tabValue],
                  transition: 'width 0.3s ease-in-out',
                },
              }}
            >
              <Tab label="Details" value={0} style={{ borderBottom: '60px !important' }} />
              <Tab label="Assessments" value={1} style={{ margin: '0px 25px' }} />
              <Tab label="Reports" value={2} onClick={() => { groupReportCtx.setOpenReport(true); }} />
            </Tabs>

            {asmtCtx.tabValue === 0 &&
              (!editProfile ? (
                <Box p={3}>
                  <div className="info-body-details">
                    <div className="row-one">
                      <div className="name-info-client">
                        <p className="info-client-head">Name</p>
                        <p className="info-client-body text-capital">{client?.name || client?.title?.split(' ')[0]}</p>
                      </div>
                      <div className="name-info-client">
                        <p className="info-client-head">Company Name</p>
                        <p className="info-client-body text-capital">{client?.company || 'Wayne EnterPrises'}</p>
                      </div>
                      <div className="name-info-client">
                        <p className="info-client-head">Group ID</p>
                        <p className="info-client-body text-capital" style={!client?.groupid ? { display: 'flex', marginLeft: '25px' } : {}} >
                          {client?.groupid || '_'}
                        </p>
                      </div>
                    </div>
                    <div className="row-two">
                      <div className="name-info-client">
                        <p className="info-client-head">Email</p>
                        <p className="info-client-body">{client?.email || 'brucewayne@gmail.com'}</p>
                      </div>
                      <div className="name-info-client">
                        <p className="info-client-head">Title</p>
                        <p className="info-client-body text-capital">{client?.title}</p>
                      </div>
                      <div className="name-info-client">
                        <p className="info-client-head">Date Added</p>
                        <p className="info-client-body">
                          {client?.created_at
                            ? (() => {
                                const date = new Date(client.created_at);
                                const month = date.toLocaleString('en-US', { month: 'short' });
                                const day = String(date.getDate()).padStart(2, "0");
                                const year = date.getFullYear();
                                return `${month} ${day} ${year}`;
                              })()
                            : ''}
                        </p>
                      </div>
                    </div>
                    <div className="row-three">
                      <div className="name-info-client">
                        <p className="info-client-head">Phone</p>
                        <p className="info-client-body">{formatPhoneNumber(client?.phone) || '(555) 123-4567'}</p>
                      </div>
                      <div className="name-info-client">
                        <p className="info-client-head">Industry</p>
                        <p className="info-client-body text-capital">{client?.industry || 'Weapon Technology'}</p>
                      </div>
                    </div>
                  </div>
                  <button className="edit-profile" onClick={() => setEditProfile(true)}>
                    Edit Profile
                  </button>
                  {showSuccessMessage && (
                    <div className="client-add" style={{ marginTop: '20px' }}>
                      <img className="client-add-img" src={greentick} alt="" />
                      <p> &nbsp;You have successfully updated{' '} {client?.name ? client.name.replace(/\b\w/g, (char) => char.toUpperCase()) : 'the client'} 's details. </p>
                    </div>
                  )}
                </Box>
              ) : (
                <>
                  <form className="client-form" onSubmit={handleSubmit}>
                    <div className="edit-form">
                      <div className="form-col-one">
                        <div className={`client-info ${errors.firstnameError ? 'error' : ''}`}>
                          <p className="client-info-p"> First Name<span className="asterisk-mark">*</span> </p>
                          <input type="text" name="firstname" className="client-input" placeholder="e.g. Simon " value={formValues?.firstname} onChange={handleFormChange} required />
                          {errors.firstnameError && <div className="form-error">{errors.firstnameError}</div>}
                        </div>
                        <div className={`client-info ${errors.emailError ? 'error' : ''}`}>
                          <p className="client-info-p"> Email<span className="asterisk-mark">*</span> </p>
                          <input type="email" name="email" className="client-input" placeholder="e.g. simonpeter@petra.org" value={formValues?.email} onChange={handleFormChange} required />
                          {errors.emailError && <div className="form-error">{errors.emailError}</div>}
                        </div>
                        <div className={`client-info ${errors.titleError ? 'error' : ''}`}>
                          <p className="client-info-p"> Title<span className="asterisk-mark">*</span> </p>
                          {formValues.type_text?.length > 0 || formValues.title === 'Other' ? (
                            <>
                              <div className="title-type-text">
                                <input type="text" name="type_text" className="client-input" placeholder="Start typing" value={formValues.type_text} onChange={handleFormChange} required />
                                <Button className="close-btn-typed-text" onClick={() => { setFormValues({ ...formValues, type_text: '', title: '' }); }} type="button" >
                                  <img src={cross} alt="cross" className="cross-image" />
                                </Button>
                              </div>
                              {errors.titleError && <div className="form-error">{errors.titleError}</div>}
                            </>
                          ) : (
                            <>
                              <Select name="title" placeholder={'Select/type your title'} value={titles.find((option) => option.value === formValues.title)} onChange={(selectedOption) => handleSelectChange(selectedOption, 'title')} required styles={customStyles} options={titles} />
                              {errors.titleError && <div className="form-error">{errors.titleError}</div>}
                            </>
                          )}
                        </div>
                        <div className={`client-info ${errors.industryError ? 'error' : ''}`}>
                          <p className="client-info-p"> Industry<span className="asterisk-mark">*</span> </p>
                          <Select name="industry" placeholder={'Select your industry'} value={industries.find((option) => option.value === formValues.industry)} onChange={(selectedOption) => handleSelectChange(selectedOption, 'industry')} required styles={customStyles} options={industries} />
                          {errors.industryError && <div className="form-error">{errors.industryError}</div>}
                        </div>
                      </div>
                      <div className="form-col-two">
                        <div className={`client-info ${errors.lastnameError ? 'error' : ''}`}>
                          <p className="client-info-p"> Last Name<span className="asterisk-mark">*</span> </p>
                          <input type="text" name="lastname" className="client-input" placeholder="e.g. Petra" value={formValues?.lastname} onChange={handleFormChange} required />
                          {errors.lastnameError && <div className="form-error">{errors.lastnameError}</div>}
                        </div>
                        <div className={`client-info ${errors.phoneError ? 'error' : ''}`}>
                          <p className="client-info-p"> Phone<span className="asterisk-mark">*</span> </p>
                          <input type="text" name="phone" className="client-input" placeholder="e.g. (555) 123-4567" value={formValues?.phone} onChange={handleFormChange} required />
                          {errors.phoneError && <div className="form-error">{errors.phoneError}</div>}
                        </div>
                        <div className={`client-info ${errors.companyError ? 'error' : ''}`}>
                          <p className="client-info-p"> Company<span className="asterisk-mark">*</span> </p>
                          <input type="text" name="company" className="client-input" placeholder="Type your company name" value={formValues?.company} onChange={handleFormChange} required />
                          {errors.companyError && <div className="form-error">{errors.companyError}</div>}
                        </div>
                        <div className={`client-info ${errors.groupIDError ? 'error' : ''}`}>
                          <p className="client-info-p">Group ID</p>
                          <input type="text" name="groupID" className="client-input" placeholder="e.g. Simon123" value={formValues?.groupID} onChange={handleFormChange} />
                          {errors.groupIDError && <div className="form-error">{errors.groupIDError}</div>}
                        </div>
                      </div>
                    </div>
                    <div className="client-cta">
                      {isLoading ? (
                        <Button className="client-button" disabled> {<CircularProgress size={20} style={{ color: '#fff' }} />} </Button>
                      ) : (
                        <Button className="client-button" type="submit"> Save Changes </Button>
                      )}
                    </div>
                  </form>
                </>
              ))}

            {asmtCtx.tabValue === 1 && (
              <Box p={3}>
                <div className="member">
                  <Assessment clientId={client?.id} clientData={client} setValue={asmtCtx.setTabValue} onClientDataUpdate={setClient} />
                </div>
              </Box>
            )}

            {asmtCtx.tabValue === 2 && (
              <Box p={3}>
                <div className="assessmentscores" style={{ marginTop: '-24px' }}>
                  <Reports
                    clientData={client}
                    clientId={client?.id}
                    selectedReportParams={selectedReportParams}
                    setSelectedReportParams={setSelectedReportParams}
                  />
                </div>
              </Box>
            )}
          </Box>
        </div>
      </div>
    </div>
  );
};

export default CreateAssessment;
